import React from 'react'
import {Button, Modal} from 'react-bootstrap'

export default function NotApprovedMilestoneModal({show, onHide, message}){
  return <Modal show={show} onHide={onHide} centered>
    <Modal.Header>
      <Modal.Title>Причина отклонения</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {message}
    </Modal.Body>
    <Modal.Footer>
      <Button variant='outline-primary' onClick={onHide}>ОК</Button>
    </Modal.Footer>
  </Modal>
}